import { REVERSAL } from "@/mocks/gossip";

export default function ReversalStory() {
  const steps = REVERSAL.timeline;
  return (
    <section id="reversal" className="bg-paper-100 border-y border-ink-200/60 py-12 md:py-20 scroll-mt-24">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3">
          <span className="w-10 h-1.5 rounded-full bg-rose-500" />
          <p className="text-sm font-semibold tracking-wide text-ink-700">反 转 追 踪</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start mt-6">
          {/* 左侧焦点头图 */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="relative rounded-2xl overflow-hidden shadow-soft">
              <img
                src={REVERSAL.image}
                alt="《落日信箱》反转时间线复盘 焦点事件配图"
                className="w-full h-72 md:h-[360px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink-900/80 via-ink-900/10 to-transparent" />
              <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-rose-500 text-paper-50 text-xs font-bold">
                <i className="ri-arrow-left-right-line text-sm" />
                {REVERSAL.eyebrow}
              </span>
              <div className="absolute bottom-0 inset-x-0 p-6 text-paper-50">
                <p className="font-heading text-lg md:text-xl font-bold leading-snug">{REVERSAL.title}</p>
                <p className="text-xs text-paper-100/80 mt-2 leading-relaxed line-clamp-2">{REVERSAL.lead}</p>
              </div>
            </div>

            <div className="mt-5 grid grid-cols-3 gap-3">
              {[
                { k: "在看", v: REVERSAL.stats.watch, ic: "ri-eye-line" },
                { k: "更新进度", v: REVERSAL.stats.update, ic: "ri-refresh-line" },
                { k: "实锤节点", v: REVERSAL.stats.verified, ic: "ri-verified-badge-line" },
              ].map((s) => (
                <div key={s.k} className="rounded-xl bg-paper-50 border border-ink-200/60 p-3 text-center">
                  <i className={`${s.ic} text-brand-500 text-lg`} />
                  <p className="text-[13px] font-bold text-ink-900 mt-1 leading-tight">{s.v}</p>
                  <p className="text-[11px] text-ink-500 mt-0.5">{s.k}</p>
                </div>
              ))}
            </div>

            <p className="mt-5 text-sm text-ink-600 leading-relaxed border-l-4 border-amber-400 pl-4">
              {REVERSAL.lead}
            </p>
          </div>

          {/* 右侧时间线 */}
          <div className="lg:col-span-7">
            <div className="flex items-center justify-between flex-wrap gap-2 mb-6">
              <h2 className="font-heading font-black text-3xl text-ink-900">四天，一场反转怎么发生的</h2>
              <span className="text-xs px-3 py-1 rounded-full bg-paper-50 border border-ink-200 text-ink-500">
                已更新至最新节点
              </span>
            </div>

            <div className="relative pl-0">
              <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-brand-200" />
              <ol className="space-y-5">
                {steps.map((s, i) => {
                  const isLast = i === steps.length - 1;
                  return (
                    <li key={i} className="relative flex gap-5">
                      <div className="relative z-10 flex flex-col items-center shrink-0">
                        <span
                          className={`w-10 h-10 rounded-full flex items-center justify-center font-heading font-black text-sm ${
                            isLast ? "bg-rose-500 text-paper-50" : "bg-brand-500 text-paper-50"
                          }`}
                        >
                          {String(i + 1).padStart(2, "0")}
                        </span>
                      </div>
                      <div className="flex-1 rounded-xl bg-paper-50 border border-ink-200/60 p-5 card-lift hover:-translate-y-0.5 hover:shadow-soft">
                        <div className="flex items-center gap-2 flex-wrap">
                          <h3 className="font-heading font-bold text-lg text-ink-900">{s.title}</h3>
                          {isLast && (
                            <span className="text-[11px] px-2 py-0.5 rounded-full bg-mint-100 text-mint-600 font-semibold">
                              最新进度
                            </span>
                          )}
                        </div>
                        <p className="text-xs text-brand-600 mt-0.5">{s.date}</p>
                        <p className="text-sm text-ink-700 leading-relaxed mt-2">{s.summary}</p>
                        {s.evidence && (
                          <p className="mt-3 text-xs leading-relaxed bg-amber-50 border border-amber-200/70 rounded-lg px-3 py-2 text-amber-600">
                            <i className="ri-verified-badge-line mr-1" />
                            佐证：{s.evidence}
                          </p>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ol>
            </div>

            <div className="mt-6 rounded-xl bg-ink-900 text-paper-50 px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="flex-1">
                <p className="font-semibold">想看后续怎么走？顺着持续更新就能读。</p>
                <p className="text-sm text-paper-100/70 mt-1">关键方回应口径有变化，我们会第一时间补充新节点。</p>
              </div>
              <a
                href="#about"
                className="inline-flex items-center gap-1.5 px-5 h-10 rounded-full bg-amber-400 text-ink-900 text-sm font-bold hover:bg-amber-300 whitespace-nowrap transition-colors"
              >
                关于今日热瓜
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}